import type { StoresType } from 'api/Stores'
import type { ChannelSummaryType } from 'ChannelSummary/types'
import type { DetailsData } from 'data/types'

export function isValidTemperature(temperature?: number | null) {
  return temperature !== undefined && temperature !== null && (temperature === 0 || temperature > 0 || temperature < 0)
}

interface GetDefaultContentType {
  data: DetailsData
  type: ChannelSummaryType
}

export function getDefaultContentType({ data, type }: GetDefaultContentType): StoresType {
  const isGroup = type === 'group'

  if (isGroup || data.anyStoresNECom) {
    return 'stores'
  }

  if (isGroup || data.anyStoresECom) {
    return 'websites'
  }

  return 'default'
}
